import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

type ForgeBannerPresetHeightConfig = {
	presetHeight: number;
	removalDelay: number;
	maxDelay: number;
};

export const DEFAULT_FORGE_BANNER_PRESET_HEIGHT_CONFIG: ForgeBannerPresetHeightConfig = {
	presetHeight: 0,
	removalDelay: 100,
	maxDelay: 10000,
};

// The SSR layout and the app must agree on the reservation, including when only a
// presetHeight is configured. Timings default to the existing iframe handoff delays.
export const getForgeBannerPresetHeightConfig = (): ForgeBannerPresetHeightConfig => {
	try {
		const config = JSON.parse(
			StatsigConfigurations.getString('confluence_forge_banner_preset_height', ''),
		) as {
			presetHeight?: unknown;
			removalDelay?: unknown;
			maxDelay?: unknown;
		};

		if (expValEquals('confluence_ssr_forge_page_banner', 'isEnabled', true)) {
			const {
				presetHeight,
				removalDelay = DEFAULT_FORGE_BANNER_PRESET_HEIGHT_CONFIG.removalDelay,
				maxDelay = DEFAULT_FORGE_BANNER_PRESET_HEIGHT_CONFIG.maxDelay,
			} = config;
			if (
				typeof presetHeight !== 'number' ||
				!Number.isFinite(presetHeight) ||
				presetHeight < 0 ||
				typeof removalDelay !== 'number' ||
				!Number.isFinite(removalDelay) ||
				removalDelay < 0 ||
				typeof maxDelay !== 'number' ||
				!Number.isFinite(maxDelay) ||
				maxDelay < 0
			) {
				return DEFAULT_FORGE_BANNER_PRESET_HEIGHT_CONFIG;
			}
			return { presetHeight, removalDelay, maxDelay };
		}

		if (
			typeof config.presetHeight !== 'number' ||
			typeof config.removalDelay !== 'number' ||
			typeof config.maxDelay !== 'number'
		) {
			return DEFAULT_FORGE_BANNER_PRESET_HEIGHT_CONFIG;
		}
		return config as ForgeBannerPresetHeightConfig;
	} catch {
		return DEFAULT_FORGE_BANNER_PRESET_HEIGHT_CONFIG;
	}
};
